import React, {useEffect, useState} from 'react'
import {Col, Row} from 'react-bootstrap'
import Box from '../component/Box/Box'
import BreadcrumbItem from '../component/BreadcrumbItem/BreadcrumbItem'
import Page from '../component/Page/Page'
import Table from '../component/Table/Table'
import Notify from '../services/Notify'
import {dayMonthYearAtTimeWithSeconds} from '../utils/dates'
import MovementOrderService from './MovementOrderService'
import LoadingV2 from "../component/Loading/LoadingV2";

export const MOVEMENT_ORDER_STATUS = {
  PENDING: 'Pendente',
  INITIATED: 'Inicializado',
  PAUSED: 'Pausado',
  FINISHED: 'Finalizado'
}

const LabelComponent = ({title, content}) => {
  return (
      <Col md={6} className="d-flex mt-3 align-items-center">
        <h5 className="font-weight-bold">{title}:&ensp;</h5>
        <h5>{content}</h5>
      </Col>
  )
}

function MovementOrderDetailsPage({match}) {

  const [movementOrder, setMovementOrder] = useState({destination: {}, products: []});
  const [isLoading, setIsLoading] = useState(false);

  const getMovementOrder = async () => {
    try {
      setIsLoading(true);
      const movementOrder = await new MovementOrderService().findById(match.params.id);
      setMovementOrder(movementOrder);
    } catch (error) {
      Notify.error('Falha ao buscar ordem de movimentação', error);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getMovementOrder();
  }, [])

  const breadcrumbs = [
    <BreadcrumbItem to="/list/movement-orders" title="Lista de ordem de movimentação" key={1}/>,
    <BreadcrumbItem title="Detalhe da movimentação" key={2}/>
  ];

  const {code, destination, status, createdAt} = movementOrder;
  return (
      <Page breadcrumbs={breadcrumbs} title="Detalhes da ordem de movimentação">
        <LoadingV2 isLoading={isLoading} message="Carregando ordem de movimentação!">
          <Row className="align-items-center">
            <LabelComponent title="Código" content={code}/>
            <LabelComponent title="Destino" content={destination.friendlyName}/>
            <LabelComponent title="Data de criação"
                            content={dayMonthYearAtTimeWithSeconds(createdAt)}/>
            <LabelComponent title="Status" content={MOVEMENT_ORDER_STATUS[status]}/>
            <Col className="mt-5" sm={12} >
              <Box title="Produtos">
                <Table>
                  <thead>
                  <tr>
                    <th>Referência</th>
                    <th>Nome</th>
                    <th>Quantidade</th>
                  </tr>
                  </thead>
                  <tbody>
                  {
                    movementOrder.products.map(({productType, quantity}) => (
                        <tr key={productType.id}>
                          <td>{productType.reference}</td>
                          <td>{productType.friendlyName}</td>
                          <td>{quantity}</td>
                        </tr>
                    ))
                  }
                  </tbody>
                </Table>
              </Box>
            </Col>
          </Row>
        </LoadingV2>
      </Page>
  )
}

export default MovementOrderDetailsPage



// WEBPACK FOOTER //
// ./src/movementOrder/MovementOrderDetailsPage.js